
import './comming-soon.scss';
import airplain from '../../assets/images/airplain.png'
import { useTranslation } from 'react-i18next';
import { useOutletContext } from 'react-router';
import { useLayoutEffect } from 'react';


const CommingSoon = () => {

    const [t] = useTranslation();
    const context = useOutletContext();

    useLayoutEffect(() => context.reloadState?.[1](false), []);

    return <div className="comming-soon">
        <img src={airplain} alt="comming-soon"></img>
        <div>
            <h1 className='headline'>{t('general.comming soon')}</h1>
            <p className='notes'>{t('general.the site still not avalible on mobile')}</p>
        </div> </div>
}
export default CommingSoon;